'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExportService = function () {
  function ExportService($http, appConfig, $window) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ExportService);
    this.$http = $http;
    this.appConfig = appConfig;
    this.$window = $window;
  }

  (0, _createClass3.default)(ExportService, [{
    key: 'exportReport',
    value: function exportReport(reportName, criteria) {
      var frm = $('#frmPrint');
      frm.attr('action', this.appConfig.apiServiceBaseUri + ('api/export/report/' + reportName));
      $('#postdata').val((0, _stringify2.default)(criteria));
      frm.submit();
    }
  }, {
    key: 'serialize',
    value: function serialize(obj) {
      var str = [];
      for (var p in obj) {
        if (obj.hasOwnProperty(p)) {
          if (Array.isArray(obj[p])) {
            obj[p].map(function (item) {
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(item));
            });
          } else {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          }
        }
      }return str.join("&");
    }
  }]);
  return ExportService;
}();

exports.default = ExportService;


// WEBPACK FOOTER //
// ./client/app/common/services/export.service.js